import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { TestPage } from "./ui";

export const TestPageRoute = (...rest: RouteObject[]): RouteObject => {
  return {
    path: `/test-page`,
    element: createElement(TestPage),
    children: [...rest],
  };
};

/** Same check as in `entities/api` — only Vite dev server (`yarn dev`), not builds. */
const isViteServe = import.meta.env.VITE_COMMAND === "serve";

/** Routes for `/test-page` — registered only when running `yarn dev`. */
export function getTestPageRoutes(): RouteObject[] {
  return isViteServe ? [TestPageRoute()] : [];
}
